import { render } from "./FormPageSlug.vue?vue&type=template&id=480c68c7"
import script from "./FormPageSlug.vue?vue&type=script&lang=js"
export * from "./FormPageSlug.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/FormCustom/FormPageSlug.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "480c68c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('480c68c7', __exports__)) {
    console.log('reload')
    api.reload('480c68c7', __exports__)
  }
  
  module.hot.accept("./FormPageSlug.vue?vue&type=template&id=480c68c7", () => {
    console.log('re-render')
    api.rerender('480c68c7', render)
  })

}


export default __exports__